import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { Modal } from "components/common/Modal";
import { AssetRetrieval } from "types/assetRetrieval";

interface AssetRetrievalCancelModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  assetRetrieval: AssetRetrieval | null;
  onConfirm: () => void;
  loading?: boolean;
}

export function AssetRetrievalCancelModal({
  open,
  setOpen,
  assetRetrieval,
  onConfirm,
  loading = false,
}: AssetRetrievalCancelModalProps) {
  if (!assetRetrieval) return null;

  const getRefundMessage = (state: string) => {
    switch (state) {
      case "order_placed":
        return {
          title: "Are you sure you want to cancel this order?",
          message: "You will receive a full refund for this order.",
          secondaryMessage: "Order Number: " + assetRetrieval.orderNumber,
        };
      case "labels_printed":
      case "package_out_to_employee":
        return {
          title: "Are you sure you want to cancel this order?",
          message: (
            <>
              Your employee will still receive the box. No return needed.
              <br />
              This order is not eligible for a refund.
            </>
          ),
          secondaryMessage: "Order Number: " + assetRetrieval.orderNumber,
        };
      default:
        return {
          title: "Are you sure you want to cancel this order?",
          message: "Are you sure you want to cancel this order?",
          secondaryMessage: "Order Number: " + assetRetrieval.orderNumber,
        };
    }
  };

  const { title, message, secondaryMessage } = getRefundMessage(assetRetrieval.state);

  return (
    <Modal open={open} setOpen={setOpen}>
      <Box>
        <Box sx={{ textAlign: "center" }}>
          <Cancel color="error" sx={{ fontSize: "60px" }} />
          <Typography mt={1} variant="h5" component="h2" fontWeight={800}>
            {title}
          </Typography>
          <Typography mt={0.5} color="text.secondary">
            {message}
          </Typography>
          <Typography mt={0.5} color="text.secondary">
            {secondaryMessage}
          </Typography>

          <Box mt={3} sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "center" }}>
            <Button variant="outlined" onClick={() => setOpen(false)} disabled={loading}>
              Keep Order
            </Button>
            <Button variant="contained" onClick={onConfirm} disabled={loading} color="error">
              {loading ? "Canceling..." : "Yes, cancel this order"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
